import { Observable } from 'rxjs';

import { ProjectCreateParams, ProjectUpdateParams, Projects, ReportCreateParams } from '../models/project.model';
import { Unit, UnitCreateParams, UnitUpdateParams } from '../models/unit.model';
import { UserTimezone } from '../models/user.model';
import { Period } from '../models/utility.model';

export abstract class ProjectUsecase {
  abstract get projects$(): Observable<Projects>;
  abstract get period$(): Observable<Period>;
  abstract get unitUpdateNotice$(): Observable<void>;

  abstract changeTimezone(timezone: UserTimezone): void;
  abstract changePeriod(period: Period): void;

  abstract createProject(params: ProjectCreateParams): Observable<never>;
  abstract updateProject(projectId: string, params: ProjectUpdateParams): Observable<never>;
  abstract deleteProject(projectId: string): Observable<never>;
  abstract getConsentForm(projectId: string, consentId: string): Observable<string>;
  abstract createReport(projectId: string, params: ReportCreateParams): Observable<never>;

  abstract createUnit(projectId: string, params: UnitCreateParams): Observable<string>;
  abstract updateUnit(projectId: string, unitId: string, params: UnitUpdateParams): Observable<Unit>;
  abstract updateUnitAssign(projectId: string, unitId: string): Observable<never>;
  abstract deleteUnit(projectId: string, unitId: string): Observable<never>;
}
